export const APARTMENTS_TYPES = {
  LOAD_APARTMENTS: "LOAD_APARTMENTS",
  SET_APARTMENTS: "SET_APARTMENTS",
  CLEAR_APARTMENTS: "CLEAR_APARTMENTS",
  // new facility
  NEW_APARTMENT: "NEW_APARTMENT",
  SET_UPSERT_APARTMENT: "SET_UPSERT_APARTMENT",

  EDIT_APARTMENT: "EDIT_APARTMENT",
  ASSIGN_METER: "ASSIGN_METER",
  ASSIGN_CUSTOMER: "ASSIGN_CUSTOMER",
  ASSIGN_CONTRACT: "ASSIGN_CONTRACT",
  SELECTED_METER: "SELECTED_METER",
  SEARCH_CUSTOMERS: "SEARCH_CUSTOMERS",
  HANDLE_APARTMENTS_INPUTS: "HANDLE_APARTMENTS_INPUTS",
};
